import bonusesShuffleFloatLeft from "../../../../resources/bonusesShuffleFloatLeft.png";
import bonusesShuffleFloatRight from "../../../../resources/bonusesShuffleFloatRight.png";
import {NavLink} from "react-router-dom";
import React from "react";
import bonusesRollFloatLeft from "../../../../resources/bonusesRollFloatLeft.png";
import bonusesRollFloatRight from "../../../../resources/bonusesRollFloatRight.png";

const RollRewards = () => {

    return (<div className="landingBonus roll">
        <img src={bonusesRollFloatLeft} className={'floatingTopLeft floating'} alt=""/>
        <img src={bonusesRollFloatRight} className={'floatingTopRight floatingC'} alt=""/>
        <div className="landingBonusContent">
            <div className="textTop">
                DEPOSIT BONUS
            </div>
            <div className="textBody">
                <div className="signupSteps">
                    <div className="signupStep">
                        <div className="stepNumber">
                            <div className="stepWrapper">1</div>
                        </div>
                        <div className="stepContent">Sign Up under code <span
                            className="white">“Kazlic”</span> or click the button to instantly
                            Register
                        </div>
                    </div>
                    <div className="signupStep">
                        <div className="stepNumber">
                            <div className="stepWrapper">2</div>
                        </div>
                        <div className="stepContent">You will receive access to <span className="white">5% DEPOSIT BONUS</span>
                        </div>
                    </div>
                    <div className="signupStep">
                        <div className="stepNumber">
                            <div className="stepWrapper">3</div>
                        </div>
                        <div className="stepContent">Every active player will be able to participate
                            in the leaderboard
                        </div>
                    </div>
                </div>
            </div>
            <div className="ctaButton">
                <NavLink to="https://csgoroll.com/r/KAZLIC" target={"_blank"}
                         className="btn btn-roll w-100">JOIN NOW</NavLink>
            </div>
        </div>
    </div>);

}
export default RollRewards;